import React from "react";
import {
  Box,
  CardMedia,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
  useTheme,
} from "@mui/material";
import { EGButton } from "../../../../../MainComponents/Button/EGButton/EGButton";
import { useTranslation } from "react-i18next";
import Ethiquin from "../../../../../../assets/images/Ethiquin/alerta_robot.svg";

export const FinishConfirm = ({
  open,
  onClose,
  onCancel,
  onConfirm,
  isMobil,
  isLoading,
}) => {
  const [t] = useTranslation("investigation");
  const theme = useTheme();

  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth="md"
      sx={{
        "& .MuiPaper-root": { border: `1px solid ${theme.palette.error.main}` },
      }}
    >
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1r", md: "5fr 7fr" },
          minHeight: "100%",
        }}
      >
        {!isMobil && (
          <Box>
            <CardMedia
              component="img"
              src={Ethiquin}
              alt="Finish Interview Illustration"
              sx={{
                width: "70%",
                height: "auto",
                mx: "auto",
                my: 2,
                p: 1,
                userSelect: "none",
                WebkitUserSelect: "none",
                MozUserSelect: "none",
                msUserSelect: "none",
                WebkitTouchCallout: "none",
                WebkitUserDrag: "none",
              }}
            />
          </Box>
        )}
        <Box sx={{ m: "auto", px: 2 }}>
          <Typography
            color="primary.dark"
            fontWeight={700}
            fontSize={25}
            textAlign="center"
          >
            {t("Interview.finish_interview")}
          </Typography>
          <DialogContent
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography
              component="span"
              fontWeight={500}
              fontSize={16}
              color="textPrimary"
              textAlign="center"
            >
              {t(
                "Interview.once_finish_interview_will_be_closed_and_ready_for_evaluation"
              )}
            </Typography>
          </DialogContent>
          <DialogActions
            sx={{
              px: 2,
              py: 1,
              gap: 3,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <EGButton
              label={t("Interview.finish")}
              onClick={onConfirm}
              color="primary"
              size="medium"
              loading={isLoading}
            />
            <EGButton
              label={t("Interview.cancel")}
              onClick={onCancel || onClose}
              color="secondary"
              size="medium"
              loading={isLoading}
            />
          </DialogActions>
        </Box>
      </Box>
    </Dialog>
  );
};
